import React from 'react';
import HomeHero from './HomeHero';
import { AudienceCards, AboutPreview, ThreeSteps, TrialPromo } from './HomeSections';
import OurServices from './OurServices';
import Events from './Events';
import NaturalDisasters from './NaturalDisasters';

const HomeComponent = () => {
  return (
    <>
      <HomeHero />
      <AudienceCards />
      <AboutPreview />
      <div className="mrf-alternate">
        <ThreeSteps />
        <OurServices />
        <TrialPromo />
        <Events />
        <NaturalDisasters />
      </div>
    </>
  )
}

export default HomeComponent
